import React  from 'react'
import { Button, useRefresh, useNotify, useUnselectAll, } from 'react-admin'
import IconBlock from '@material-ui/icons/Block'
import { removeAssignCategory } from '../../../Model/Shop'


const handleAssignClick = (shopid, selectedIds, resource, refresh, notify, unselectAll) => {
    const data = {
        "shop_id":shopid,
        "sid[]":selectedIds,
    }
    removeAssignCategory(data,shopid, (res) => {
        refresh()
        unselectAll(resource)
        notify(res.message)
    }, (res) => {
        notify(res.message,'warning')
    })
}

const RemoveAssignedCategoryButton = ({shopid, selectedIds, resource })=> {
    const refresh = useRefresh()
    const notify = useNotify()
    const unselectAll = useUnselectAll()
    return (
        <Button label="Remove Assigned Category" color="secondary" icon={<IconBlock />} onClick={()=>{
            handleAssignClick(shopid, selectedIds, resource, refresh, notify, unselectAll)
        }} />
    );
}

export default RemoveAssignedCategoryButton